/**
 * Return whether current session is in a VSCode WebView.
 */
export default window.navigator.userAgent.includes('Electron');
